// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"loadingSpinner_spinnerWrapper__tCPKg","hasPadding":"loadingSpinner_hasPadding__wJqIA","spinner":"loadingSpinner_spinner__DpTLa"};